import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StatusState } from '../reducers';

export const selectStatusState = createFeatureSelector<StatusState>('status');

export const selectStateLoading = createSelector(
  selectStatusState,
  (state: StatusState) => state.loading
);

export const selectStateList = createSelector(
  selectStatusState,
  (state: StatusState) => state.statusList
);

export const selectStateError = createSelector(
  selectStatusState,
  (state: StatusState) => state.error
);
